import validate from 'lib/utils/validationRules';

const getWalletList = (state) => state.walletList;

const getLinkedWallet = (state) => state.walletList.find(wallet => wallet.linkedForPayout);

const isEmptyWalletList = (state) => validate.isEmptyArray(state.walletList);

const isNoLinkedWallet = (state, getters) => validate.isUndefined(getters.getLinkedWallet);

const isSingleAvailableWallet = (state) => validate.isFixedLengthArray(state.walletList, 1);

const isLinkedWalletInBlacklisted = (state, getters) => {
  const { getLinkedWallet: { blacklisted } } = getters;

  if (getters.isNoLinkedWallet) {
    return false;
  }

  return blacklisted ?? false;
};

export default {
  getWalletList,
  getLinkedWallet,
  isEmptyWalletList,
  isNoLinkedWallet,
  isSingleAvailableWallet,
  isLinkedWalletInBlacklisted,
};
